// extracted by mini-css-extract-plugin
export default {"container":"PropertyPageDescription_container__izxJX","description":"PropertyPageDescription_description__Ira0A","noDescription":"PropertyPageDescription_noDescription__5c8KN"};